'use client';

import { Styles, css } from '@flipster/styled-system/css';
import { circle, hstack } from '@flipster/styled-system/patterns';
import { getNumberArr } from '@flipster/utils/num';

const MaskedText = ({ length }: { length: number }) => {
  return (
    <span className={hstack({ display: 'inline-flex', gap: 2, px: 4 })}>
      {getNumberArr(length).map((i) => (
        <span className={circle({ w: 4, h: 4, bgColor: 'currentcolor' })} key={i} aria-hidden />
      ))}
    </span>
  );
};

interface MaskedEmailProps {
  email?: string;
  css?: Styles;
}

export const MaskedEmail = ({ email, css: cssProps }: MaskedEmailProps) => {
  if (!email) return null;

  const [nickname, domain] = email.split('@');
  if (!domain) return null;

  const [, tld] = domain.split('.');

  return (
    <div className={css(hstack.raw({ display: 'inline-flex' }), cssProps)} translate='no'>
      {nickname.substring(0, 2)}
      <MaskedText length={3} />
      @
      <MaskedText length={3} />
      {`.${tld}`}
    </div>
  );
};

interface MaskedPhoneNumberProps {
  phoneNumber?: string;
  css?: Styles;
}

// https://prex.atlassian.net/browse/PREX-17786
// 맨 앞 2자리, 맨 뒤 2자리 제외 Asterisk 3개로 고정.
export const MaskedPhoneNumber = ({ phoneNumber, css: cssProps }: MaskedPhoneNumberProps) => {
  if (!phoneNumber) return null;

  return (
    <div className={css(hstack.raw({ display: 'inline-flex' }), cssProps)}>
      {phoneNumber.slice(0, 3)}
      <MaskedText length={8} />
      {phoneNumber.slice(phoneNumber.length - 2)}
    </div>
  );
};
